<div class="modal-header">
    <h3 class="dialog-title text-center">{{'Mark as Outlier' | translate}}</h3>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <h5 class="d-flex justify-content-center fs-16 text-bold">
                {{'Provide a reason for marking this sample as an outlier' | translate}}
            </h5>
        </div>
    </div>
    <div class="form-fields-body">
        <div class="row">
            <mat-form-field appearance="outline" class="col-md-12">
                <mat-label>{{'Outlier Reason (Required)' | translate}}</mat-label>
                <textarea matInput [(ngModel)]="data.outlierReason" rows="3"></textarea>
            </mat-form-field>
        </div>
    </div>

    <div mat-dialog-actions class="createButton mt-2">
        <button class="btn save-modal-btn w-50"
            [disabled]="!data?.outlierReason || !data.outlierReason.trim()"
            (click)="onSave()">{{'Save' | translate}}</button>
        <button class="btn cancel-modal-btn w-50" mat-dialog-close>{{'Cancel' | translate}}</button>
    </div>
</div>
